import { useMutation, useQuery } from "@tanstack/react-query";
import FETCHER from "./_fetcher";
import {
  ApplyPromotionCodeDTO,
  ApplyPromotionCodeResponse,
  IPromotionCode,
} from "types/promotionCode";

export const getPromotionCodeList = async () => {
  try {
    const result = await FETCHER.get<IPromotionCode[]>(`/promotions-code`);
    return result.data;
  } catch (e) {
    console.log(e);
  }
};
export const useGetPromotionCodeList = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["getPromotionCodeList"],
    queryFn: getPromotionCodeList,
  });
  return {
    promotionCodeList: data,
    isLoading,
  };
};

export const applyPromotionCode = async (
  promotionCode: ApplyPromotionCodeDTO
) => {
  const result = await FETCHER.post<ApplyPromotionCodeResponse>(
    `/promotions-code/apply`,
    promotionCode
  );
  return result;
};

export const useApplyPromotionCode = () => {
  // const queryClient = useQueryClient();

  const { data, mutateAsync, isPending, isError } = useMutation({
    mutationFn: applyPromotionCode,
    onSuccess: () => {
      // queryClient.invalidateQueries({
      //   queryKey: ["getPromotionCodeList"],
      // });
    },
  });
  return {
    discountAmount: data?.data.discountAmount || 0,
    applyPromotionCodeAsync: mutateAsync,
    isPending,
    isError,
  };
};
